<script setup lang="ts">
import {type Component, computed, h, useAttrs, useSlots} from "vue";
import {QIcon} from "quasar";
import InvalidIcon from "@/assets/widgetIcons/InvalidIcon.vue";
import {icons} from "@/components/icons/NamaIconList.ts";
import {NamaIconProps, StringOrUndefined} from "@/utils/presenters/interfaces.ts";
import NamaIconUtils from "@/utils/common/NamaIconUtils.ts";

const props = defineProps<NamaIconProps>()
defineSlots<{
  default(props: { namaIconColor: string, getNamaIconComponent: () => Component }): any
}>()
const slots = useSlots();

const hasColor = computed(() => !!namaIconColor.value)
const namaIconName = computed<StringOrUndefined>(() => NamaIconUtils.toIconCode(props));
const namaIconColor = computed(() => NamaIconUtils.toColorCode(props));

function getNamaIconComponent() {
  const iconName = namaIconName.value;
  if (!iconName)
    return InvalidIcon;

  let comp: Component;
  if (iconName.startsWith("nm-")) {
    if (iconName in icons)
      comp = icons[iconName]
    else
      comp = InvalidIcon
  } else
    comp = QIcon;
  let namaClass = "tw-relative nama-icon tw-shrink-0 tw-aspect-square tw-h-auto";
  const {class: classAttrs, ...attrs} = useAttrs();
  if (!(classAttrs && (<string>classAttrs).includes("-size-")) && !("default" in slots))
    namaClass += " tw-size-6"
  return h(comp, {class: namaClass, size: "sm", name: iconName, ...attrs})
}

defineExpose({
  namaIconColor,
  hasColor
})
</script>
<template>
  <template v-if="namaIconName">
    <slot v-if="$slots.default" v-bind="{namaIconColor,getNamaIconComponent}"/>
    <component v-else :is="getNamaIconComponent()" v-bind="$attrs" :class="{'colored-icon':hasColor && colored }"/>
  </template>
</template>

<style lang="scss">
.colored-icon {
  &, path {
    fill: v-bind(namaIconColor) !important;
  }
}
</style>
